var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isInitialized),expression:"isInitialized"}],ref:_vm.componentId,staticClass:"mockup-product-preview"}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isInitialized),expression:"!isInitialized"}],staticClass:"mockup-placeholder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }